import { GroupSidebarTabType } from '../../models/group-sidebar';

export class GroupSidebarDropdownComponent {
    static $inject = ['$element', '$rootScope'];
    public active: GroupSidebarTabType = 'joined';

    constructor(private element: angular.IRootElementService, private rootScope: angular.IRootScopeService) {
        rootScope.$on('group-sidebar-active-changed', (event, active: GroupSidebarTabType) => {
            this.active = active;
        });
    }

    public $onInit() {
        this.element.attr('is-uib', 'true');
    }

    public set(type: GroupSidebarTabType) {
        this.rootScope.$emit('group-sidebar-active-changed', type);
    }

    public getLabel(type: GroupSidebarTabType) {
        switch (type) {
            case 'joined':
                return 'My Groups';
            case 'own':
                return 'Own';
            case 'top':
                return 'Top';
        }
    }
}

angular.module('tradersyard').component('tyGroupSidebarDropdown', {
    template: `
    <div class="btn-group" uib-dropdown>
      <button id="single-button" type="button" class="btn btn-default" uib-dropdown-toggle ng-disabled="disabled">
        {{$ctrl.getLabel($ctrl.active)}} <span class="caret"></span>
      </button>
      <ul uib-dropdown-menu role="menu" aria-labelledby="single-button">
        <li role="menuitem"><a href="#" ng-click="$ctrl.set('joined')">My Groups</a></li>
        <li role="menuitem"><a href="#" ng-click="$ctrl.set('own')">Own</a></li>
        <li role="menuitem"><a href="#" ng-click="$ctrl.set('top')">Top</a></li>
      </ul>
    </div>
    `,
    controller: GroupSidebarDropdownComponent,
});
